/**
 * Created by cghislai on 03/08/16.
 */

export class NumberUtils {

  static isSameAmountCents(valueA: number, valueB: number): boolean {
    if (valueA == null || valueB == null) {
      return false;
    }
    const fixedA = valueA.toFixed(2);
    const fixedB = valueB.toFixed(2);
    return fixedA === fixedB;
  }

  static formatCurrency(value: number | any): string {
    if (value == null || typeof value !== 'number' || isNaN(value)) {
      return null;
    }
    const fixedDecimals = value.toFixed(2);
    const length = fixedDecimals.length;

    let parts = Math.floor(length / 3);
    let formatted = '';
    let curIndex = 0;
    let partIndex = 0;
    const isNegativeNumber = fixedDecimals.charAt(0) === '-';
    if (isNegativeNumber) {
      formatted += '-';
      curIndex = 1;
      parts = Math.floor((length - 1) / 3);
    }
    // 0 111 222 333 444
    // 0 123 456 789 012
    while (curIndex < length) {
      const partStart = curIndex;
      const partEnd = length - (parts - partIndex) * 3;
      const partVal = fixedDecimals.substring(partStart, partEnd);
      if (partIndex < parts) {
        // not last part
        const minIndex = isNegativeNumber ? 1 : 0;
        if (curIndex > minIndex) {
          formatted += ` `;
        }
        formatted += partVal;
      } else {
        formatted += ',';
        formatted += partVal.substring(1, 3);
      }
      curIndex = partEnd;
      partIndex++;
    }

    return formatted + '\u00A0€';
  }

  static formatVatNumber(vat: string): string {
    if (vat == null) {
      return vat;
    }
    const testValue = vat.replace(/ /g, '');

    const isEntrepriseNumber = /^[0-9]{3,4}\.[0-9]{3}\.[0-9]{3}$/.test(testValue);
    if (isEntrepriseNumber) {
      const noDotsValue = testValue.replace(/\./g, '');
      return 'BE' + noDotsValue;
    } else {
      return testValue;
    }
  }

}
